let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gNI1p")).then(() => parcelRequire('1WQib'));